import React, { Fragment } from "react"
import Studio from "../Studio"
import WithObject from "data/wrappers/WithObject"
import PageTitle from "ui/components/PageTitle"
import Breadcrumbs from "ui/components/Breadcrumbs"
import Container from "ui/components/Container"
import Section from "ui/components/Section"
import RecordTable from "../components/RecordTable"
import NewRecordButton from "../components/NewRecordButton"
import { Card } from "ui"

export default class RecordListPage extends React.Component {
    render() {
        return (
            <Studio>
                <WithObject objectId={this.props.params.objectId}>
                    {({ object, createRecord }) => (
                        <Container marginBottom="medium" spaced>
                            <Section margin="none" padding="none">
                                <Breadcrumbs
                                    crumbs={[
                                        { label: "Data", link: "/data" },
                                        { label: "Tables", link: "/tables" },
                                        {
                                            label: object.name,
                                            link: "/table/" + object._sid
                                        }
                                    ]}
                                />
                                <PageTitle>{object.name} Records</PageTitle>
                            </Section>
                            <NewRecordButton onSave={createRecord} object={object} />
                        </Container>
                    )}
                </WithObject>
                <Card>
                    <RecordTable objectId={this.props.params.objectId} />
                </Card>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/RecordListPage.js